var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "418A593D-6E33-49DB-A871-7405BDAC9B16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HomepageOK-1080px",
    transform: "translate(-1082.000000, -5928.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bandeau-boost",
    transform: "translate(0.000000, 5602.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(854.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desactiv",
    transform: "translate(180.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "004-switch",
    transform: "translate(48.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-2",
    fillOpacity: 0.01,
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3820998,39 L36.6179002,39 C43.9759036,39 50,32.9662379 50,25.5 C50,18.0337621 44.0189329,12 36.6179002,12 L13.3820998,12 C6.02409639,12 0,18.0337621 0,25.5 C0,32.9662379 6.02409639,39 13.3820998,39 Z M13.3820998,15.5594855 L36.6179002,15.5594855 C42.0395869,15.5594855 46.4716007,20.0305466 46.4716007,25.5 C46.4716007,30.9694534 42.0395869,35.4405145 36.6179002,35.4405145 L13.3820998,35.4405145 C7.96041308,35.4405145 3.52839931,30.9694534 3.52839931,25.5 C3.52839931,20.0305466 7.96041308,15.5594855 13.3820998,15.5594855 Z",
    id: "Shape",
    fill: "#FDC609",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,33 C17.6184971,33 21,29.6184971 21,25.5 C21,21.3815029 17.6184971,18 13.5,18 C9.38150289,18 6,21.3815029 6,25.5 C6,29.6184971 9.38150289,33 13.5,33 Z M13.5,21.5549133 C15.6676301,21.5549133 17.4450867,23.3323699 17.4450867,25.5 C17.4450867,27.6676301 15.6676301,29.4450867 13.5,29.4450867 C11.3323699,29.4450867 9.55491329,27.6676301 9.55491329,25.5 C9.55491329,23.3323699 11.3323699,21.5549133 13.5,21.5549133 Z",
    id: "Shape",
    fill: "#FDC609",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.5114e35c79d30b6ba17cf6745b83b550.svg";
export { ForwardRef as ReactComponent };